import { ClockManualIcon, HandshakeIcon, LockIcon, WifiIcon } from "@xola/icons";
import { Badge, Tooltip } from "@xola/ui-kit";
import React from "react";
import { Event, User } from "types";
import { useResource } from "../../../hooks/useResource";
import { getCreatedFromNow } from "../../../models/Event";
import { NoTranslate } from "../NoTranslate";
import { Translate } from "../Translate";
import { BannerDataProps } from "./BannerDataProps";

type BannerBadgesProps = { event?: Event } & Pick<
    BannerDataProps,
    "isManual" | "isVirtual" | "isPrivate" | "customerName" | "isPartnerExperienceBooking" | "isPartnerPackageBooking"
>;

export const BannerBadges = ({
    isManual,
    isVirtual,
    isPrivate,
    isPartnerExperienceBooking,
    isPartnerPackageBooking,
    customerName,
    event,
}: BannerBadgesProps) => {
    const { data: user } = useResource<User>(["users", event?.createdBy]);
    const ALT_TEXT = "Manually created timeslot";

    const manualPopupContent = isManual ? getCreatedFromNow(ALT_TEXT, user, event) : "";

    return (
        <div className="space-x-2">
            {isManual && (
                <Tooltip content={<Translate if={manualPopupContent === ALT_TEXT}>{manualPopupContent}</Translate>}>
                    <Badge color="secondary" className="ui-dashboard-item-manual">
                        <ClockManualIcon />
                    </Badge>
                </Tooltip>
            )}
            {isPartnerExperienceBooking && (
                <Badge color="secondary" className="flex items-center space-x-2">
                    <HandshakeIcon />
                    <span>Partner Purchase</span>
                </Badge>
            )}
            {isPartnerPackageBooking && (
                <Badge color="secondary" className="flex items-center space-x-2">
                    <HandshakeIcon />
                    <span>Partner Package</span>
                </Badge>
            )}
            {isVirtual ? (
                <Badge className="ui-dashboard-virtual">
                    <WifiIcon />
                </Badge>
            ) : null}
            {isPrivate ? (
                <Badge color="warning" icon={<LockIcon />} className="ui-dashboard-item-private no-translate">
                    <NoTranslate>{customerName}</NoTranslate>
                </Badge>
            ) : null}
        </div>
    );
};
